import React from "react";
import { CoverImage } from "./cover-image";

export const SimilarBooks = ({ similarBooks }) => {
    return (
        <section className="text-gray-600 body-font overflow-hidden">
            <div className="container px-5 py-12 mx-auto">
                <div className="-my-8 divide-y-2 divide-gray-100">
                    {similarBooks.map((book) => (
                        <a
                            className="py-8 flex flex-wrap md:flex-nowrap"
                            href={`/book/${book.id}/${book.slug}/`}
                            key={book.id}
                        >
                            <div className="w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col mx-auto">
                                <CoverImage cover_file_name={book.cover_file_name} className="h-48 object-scale-down object-center" alt={`${book.name} cover`} />
                            </div>
                            <div className="md:flex-grow">
                                <p className="text-sm title-font text-gray-500 tracking-widest">
                                    {book.authors.join(", ")}
                                </p>
                                <p className="text-2xl font-medium text-gray-900 title-font mb-2">
                                    {book.name}
                                </p>
                                {book.annotation && (<p className="leading-relaxed">{book.annotation}</p>)}
                                <span
                                    className="inline-flex items-center mt-4 text-custom-link"
                                >
                                    Learn More
                                    <svg
                                        className="w-4 h-4 ml-2"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M5 12h14"></path>
                                        <path d="M12 5l7 7-7 7"></path>
                                    </svg>
                                </span>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}